import { makeStyles } from 'tss-react/mui';

export const useGlobalMenuStyles = makeStyles()(theme => ({
  globalMenuLogo: {
    display: 'flex',

    '&&': {
      svg: {
        color: theme.palette.text.primary,
      },
    },
  },
}));
